module.exports = __webpack_public_path__ + "img/bnk-memorize.ac2bc5e1.png";